import React from "react";
import Slider from "react-slick";
import Widget from "../../Widget/Widget";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import RoadMapItem from "./RoadMapItem";
import { mediaList } from "./data";
import SetWidget from "../WidgetsExtra/SetWidget";

const RoadMap = ({ value }) => {
   const settings = {
      arrows: false,
      dots: true,
      infinite: true,
      speed: 500,
      marginLeft: 10,
      marginRight: 10,
      slidesToShow: 1,
      slidesToScroll: 1
   };
   return (
      <Widget
         extra={<SetWidget widgetId={value ? value.id : null} />}
         styleName="gx-card-full"
         heading={""}
      >
         <Slider className="gx-slick-slider" {...settings}>
            {mediaList.map((media, index) => (
               <React.Fragment key={index}>
                  <RoadMapItem key={index} data={media} />
               </React.Fragment>
            ))}
         </Slider>
      </Widget>
   );
};

export default RoadMap;
